import { useMutation } from '@tanstack/react-query'
import { postStatus } from '@/apis/Befehlsnachricht'
import { BfnStatus } from '@/models/Befehlsnachricht'
import { useBefehlsnachrichtUpdater } from '@/features/befehlsnachrichten/hooks/useBefehlsnachrichtUpdater'
import { Abruftoken } from '@/models/Abruftoken'
import { validateBfnStatusChange } from '@/features/befehlsnachrichten/utils/befehlsnachricht-status'
import { useContext } from 'react'
import HinweisContext from '@/hooks/HinweisContext'
import BefehlsnachrichtStatusTransitionError from '@/features/befehlsnachrichten/errors/BefehlsnachrichtStatusTransitionError'

export default function useBfnAbweisenMutation(abruftoken: Abruftoken) {
  const updateBefehlsnachricht = useBefehlsnachrichtUpdater()
  const { setHinweis } = useContext(HinweisContext)

  const mutation = useMutation({
    mutationFn: () => postStatus(abruftoken, BfnStatus.ABGEWIESEN),
    onSuccess: async () => {
      const befehlsnachricht = await updateBefehlsnachricht(abruftoken)

      // validate that Befehlsnachricht status changed as expected
      try {
        validateBfnStatusChange(
          befehlsnachricht.status,
          BfnStatus.ABGEWIESEN,
          befehlsnachricht.statusTimestamps
        )
      } catch (e) {
        setHinweis(
          'Unerwarteter Statuswechsel erkannt',
          (e as BefehlsnachrichtStatusTransitionError).message,
          'Bitte kontaktieren Sie den zuständigen Fahrdienstleiter.'
        )
      }
    }
  })

  return { mutation }
}
